var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MainWithDetailLayout',{attrs:{"main-route-name":_vm.mainRouteName,"is-main-full-width":!_vm.isDetailScreen}},[_c('VerticalContainer',[_c('FacilitiesTable',{attrs:{"selected-id":_vm.$route.params.id}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }